import Investors from './Investors';
import MailOut from './mailoutAll';

export const InvestorsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : ['super', 'investors', 'staff'],
    routes  : [
        {
            path     : '/investors',
            component: Investors
        },
        {
            path     : '/mailout',
            component: MailOut
        }
    ]
};
